import { Component } from '@angular/core';

@Component({
    selector: 'nio-health-care-landing-zone',
    templateUrl: './health-care-landing-zone.component.html',
    styleUrls: ['./health-care-landing-zone.component.scss'],
    standalone: false
})
export class HealthCareLandingZoneComponent {}
